module.exports = __webpack_public_path__ + "img/media-site.f341d1d1.png";